module.exports = new __parcel__URL__("joel-andre-ornstein.c3569ed5.jpeg").toString();